import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import "./backbutton.css";

const BackButton = () => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);

  return (
    <motion.button
      className="back-button"
      onClick={() => navigate(-1)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
    >
      <ArrowLeft size={24} />
      {hovered && (
        <motion.span
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -10 }}
          transition={{ duration: 0.3 }}
          className="back-text"
        >
          Back
        </motion.span>
      )}
    </motion.button>
  );
};

export default BackButton;
